import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  flightData: {},
  isLoading: false,
  error: "",
  hasData: false
};
const flightLayoutListSlice = createSlice({
  name: "flightLayoutList",
  initialState,
  reducers: {
    flightLayoutRequest: state => {
      state.isLoading = true;
    },
    flightLayoutRequestSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.flightData = action.payload;
    },
    flightLayoutRequestFailure: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
      state.hasData = true;
    }
  }
});
export const {
  flightLayoutRequest,
  flightLayoutRequestSuccess,
  flightLayoutRequestFailure
} = flightLayoutListSlice.actions;
export default flightLayoutListSlice.reducer;